
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'percentage-button',
  props: {
    modelValue: String,
    percentage: { type: Number, required: true },
    disabled: Boolean,
  },
  emits: ['update:modelValue'],
  computed: {
    getId(): string {
      return `${this.percentage}%`;
    },
  },
});
